import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../../services/contract/contract.service';
import { PerformingContract } from '@airwallet/shared-models/operator/contracts';
import moment from 'moment/moment';
import hash from 'object-hash';
import { HelperService } from 'src/app/services/helper/helper.service';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingComponent } from '../../loading/loading.component';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import { CustomToolTipComponent } from '../../misc/custom-tool-tip/custom-tool-tip.component';
import { MixpanelService } from '@services/mixpanel/mixpanel.service';
import { SidebarService } from '@services/sidebar/sidebar.service';

@Component({
    selector: 'app-contract-performance-list',
    templateUrl: './contract-performance-list.component.html',
    styleUrls: ['./contract-performance-list.component.scss'],
    imports: [CustomToolTipComponent, NgIf, RouterLink, NgFor, LoadingComponent, TranslateModule]
})
export class ContractPerformanceListComponent implements OnInit {
    loading = false;
    initLoading = true;
    performanceFingerPrint: string;

    fromDate: number;
    toDate: number;

    contracts: Record<string, (PerformingContract | '')[]>;

    constructor(
        private contractService: ContractService,
        private mixpanelService: MixpanelService,
        private helperService: HelperService,
        protected sidebarService: SidebarService
    ) {}

    async ngOnInit(): Promise<void> {
        this.initLoading = true;
        this.fromDate = moment().subtract(29, 'days').startOf('day').unix() + moment().utcOffset() * 60;
        this.toDate = moment().startOf('day').unix() + moment().utcOffset() * 60;
        await this.getContracts();
        this.initLoading = false;
    }

    async getContracts() {
        this.loading = true;
        let params = `fromDate=${this.fromDate}&toDate=${this.toDate}`;
        this.performanceFingerPrint = hash.keys(`${params}${moment()}`);
        params += `&fingerprint=${this.performanceFingerPrint}`;

        this.contracts = await this.contractService.getPerformanceContracts(params).then((response: Record<string, (PerformingContract | '')[]>) => {
            if (this.performanceFingerPrint === response['info']['fingerprint']) {
                for (const group in response) {
                    for (let i = response[group].length; i < 5; i++) {
                        response[group].push('');
                    }
                }
                this.loading = false;
                return response;
            }
        });
    }

    round(num: number): string {
        return num ? `${num < 0 ? '' : '+'}${String(this.helperService.roundToTwoDecimals(num * 100))}%` : '';
    }

    onLinkClick() {
        this.mixpanelService.track('Action: Go To List (Contract) Clicked', { action: 'go to contracts list from home' });
    }
}
